// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LabeledString from '../../../../shared/components/labeled-string/index';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import {buildDate} from '../../../../shared/services/build-date';

const WarrantyCoverageItemRowOne = (props, context) =>
    <div className='warranty-coverage-item-row-one'>
        <LabeledString
            className='starts'
            data={buildDate(props.warranty.startDate, context.user.settings.general.dateFormat.key)}
            label='STARTS'
        />
        <LabeledString
            className='expires'
            data={buildDate(props.warranty.expireDate, context.user.settings.general.dateFormat.key)}
            label='EXPIRES'
        />
        {props.warranty.timeLimit.value &&
            <LabeledString
                className='time-limit'
                data={`${props.warranty.timeLimit.value} ${props.warranty.timeLimit.unit}`}
                label='TIME_LIMIT'
            />
        }
        {props.warranty.deductibleApplies &&
            <LabeledString
                className='deductible'
                data={`${props.warranty.deductible.value} ${props.warranty.deductible.currency}`}
                label='DEDUCTIBLE'
            />
        }
    </div>;

WarrantyCoverageItemRowOne.displayName = 'WarrantyCoverageItemRowOne';
WarrantyCoverageItemRowOne.propTypes = {
    warranty: PropTypes.instanceOf(Warranty).isRequired
};
WarrantyCoverageItemRowOne.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default WarrantyCoverageItemRowOne;



// WEBPACK FOOTER //
// ./src/product/details/components/warranty-coverage-panel/warranty-coverage-item-row-one.js